export const IMAGE_EXTENSIONS = [
  'jpg',
  'jpeg',
  'png',
  'gif',
  'webp',
  'svg',
  'bmp',
  'ico',
  'tiff',
  'tif',
];

export const VIDEO_EXTENSIONS = [
  'mp4',
  'webm',
  'ogg',
  'mov',
  'avi',
  'wmv',
  'flv',
  'mkv',
  'm4v',
  '3gp',
];
